<template>
  <div>
    <page-header>Настройки</page-header>
    <v-progress-linear v-if="loading" indeterminate />
    <div v-else>
      <v-row v-for="(setting, key) in settings" :key="key">
        <v-col>
          <v-text-field
            :label="setting.description"
            filled
            v-model="settings[key].value"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn color="primary" @click="submitSettigns(key)">Сохранить</v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import api from "../api";
import axios from "axios";
import PageHeader from "../components/PageHeader";
import store from "../store";

export default {
  name: "settings",
  components: {
    PageHeader
  },
  data() {
    return {
      settings: [],
      loading: false
    };
  },
  methods: {
    getSettings() {
      this.loading = true;
      axios
        .get(api.settings)
        .then(resp => {
          this.settings = resp.data;
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitSettigns(key) {
      this.loading = true;
      axios
        .put(api.settings + "/" + this.settings[key].id, {
          value: this.settings[key].value
        })
        .then(resp => {
          this.settings[key] = resp.data;
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted() {
    this.getSettings();
  }
};
</script>
